import React from "react";
import { Badge, BadgeProps } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { withStyles } from "@mui/styles";

export interface OcStyledBadgeProps extends BadgeProps {
  /** Whether to show the badge when `module === "MyNews"` */
  showBadge: boolean;
  /** Current module key, affects visibility logic */
  module: string;
}

export const OcStyledBadge = withStyles((theme: Theme) => ({
  badge: {
    color: theme.palette.white.main,
    backgroundColor: theme.palette.primary.main,
    borderRadius: "2px !important",
    fontFamily: "Mulish",
    fontSize: "10px !important",
    minWidth: "16px !important",
    width: "16px !important",
    height: "16px !important",
    paddingTop: "2px !important",
    fontWeight: 500,
  },
}))(({ showBadge, module, ...props }: OcStyledBadgeProps) => (
  <Badge {...props} invisible={module === "MyNews" ? !showBadge : false} />
));

export default OcStyledBadge;
